module.exports = __webpack_public_path__ + "img/washing-machine.1583ab8a.svg";